import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import React from "react";
import { Accordion, Button } from "react-bootstrap";

import { RegimeTypes } from "../../../config/filingConstants";
import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import SvgImage from "../../SvgImage";
import { ContextAwareToggle } from "../../accordion";
import {
	BPIFinancialParticularsDetails,
	BPIRevenueLessThan75lakhsDetails,
	BPIRevenueMoreThan3CroresDetails,
	CGBondsAndDebentureDetails,
	CGDeemedDetails,
	CGForeignSharesDetails,
	CGMutualFundDetails,
	CGSaleLandAndBuildingDetails,
	CGStockOptionsRSUsDetails,
	CGStocksDetails,
	OAAnyOtherAssetsDetails,
	OAVirtualDigitalAssetsDetails,
	OIAgriculturalIncomeDetails,
	OIAnyOtherIncomeDetails,
	OIDividendIncomeDetails,
	OIExemptIncomeDetails,
	OIInterestIncomeDetails,
	RIPropertiesOnRentDetails,
	RISelfOccupiedPropertiesDetails,
	SalaryIncomeDetails
} from "../../itr-filing/income-details";

type Props = {
	handleNaviagteTab: (tabName: IActiveTabs) => void;
};

const IncomeDetailsTab: React.FC<Props> = (props: Props) => {
	const { handleNaviagteTab } = props;

	const { values } = useFormikContext<IFormITR1>();
	const RegimeType = values?.FilingReturnInfo?.RegimeType || "";

	return (
		<>
			<Accordion defaultActiveKey={"income-details-0"} flush>
				<Accordion.Item eventKey="income-details-0">
					<ContextAwareToggle eventKey="income-details-0">
						<div className="btn-content">
							<SvgImage imgId="salary-information" />
							<h4 className="mb-0">
								Salary Income
								<small>Add salary income from one/multiple jobs</small>
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<SalaryIncomeDetails activeTab="INCOME" />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="income-details-1">
					<ContextAwareToggle eventKey="income-details-1">
						<div className="btn-content">
							<SvgImage imgId="rental-income-information" />
							<h4 className="mb-0">
								House Property Income
								<small>
									Please add the details if you earned rent from your house property or paid
									interest on housing loan
								</small>
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						{RegimeType === RegimeTypes.OLD_TAX_REGIME ? <RISelfOccupiedPropertiesDetails /> : null}
						<RIPropertiesOnRentDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="income-details-2">
					<ContextAwareToggle eventKey="income-details-2">
						<div className="btn-content">
							<SvgImage imgId="business-professional-income" />
							<h4 className="mb-0">Business and Professional Income</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<BPIRevenueLessThan75lakhsDetails />
						<BPIRevenueMoreThan3CroresDetails />
						<BPIFinancialParticularsDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="income-details-3">
					<ContextAwareToggle eventKey="income-details-3">
						<div className="btn-content">
							<SvgImage imgId="capital-gains" />
							<h4 className="mb-0">Capital Gains</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<CGStocksDetails />
						<CGMutualFundDetails />
						<CGForeignSharesDetails />
						<CGSaleLandAndBuildingDetails />
						<CGStockOptionsRSUsDetails />
						<CGBondsAndDebentureDetails />
						<CGDeemedDetails />
						<OAAnyOtherAssetsDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="income-details-4">
					<ContextAwareToggle eventKey="income-details-4">
						<div className="btn-content">
							<SvgImage imgId="other-income-information" />
							<h4 className="mb-0">
								Other Sources
								<small>
									Interest from savings bank, deposits or any other income that you might wish to
									declare
								</small>
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<OIInterestIncomeDetails />
						<OIDividendIncomeDetails />
						<OIAgriculturalIncomeDetails />
						<OIExemptIncomeDetails />
						<OIAnyOtherIncomeDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="income-details-5">
					<ContextAwareToggle eventKey="income-details-5">
						<div className="btn-content">
							<SvgImage imgId="virtual-digital-assets" />
							<h4 className="mb-0">Virtual Digital Assets (VDA)</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<OAVirtualDigitalAssetsDetails />
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>

			<PreventEditComponent>
				<div className="btns-wrap">
					<Button
						size="lg"
						type="button"
						variant="outline-greyDark"
						onClick={() => handleNaviagteTab("personal-details")}
					>
						<FASvgIcon icon={faArrowLeft} />
						Back
					</Button>
					<Button
						size="lg"
						type="button"
						variant="primary"
						onClick={() => handleNaviagteTab("deductions")}
					>
						Proceed <FASvgIcon icon={faArrowRight} />
					</Button>
				</div>
			</PreventEditComponent>
		</>
	);
};

export default IncomeDetailsTab;
